// extracted by mini-css-extract-plugin
export var actionButton = "_mg-0";
export var actionMenuContainer = "_mg-i";
export var bubble = "_mg-2";
export var bubbleActionMenu = "_mg-j";
export var bubbleContext = "_mg-6";
export var bubbleItems = "_mg-7";
export var customer = "_mg-3";
export var divider = "_mg-8";
export var fileList = "_mg-9";
export var hiddenComment = "_mg-o";
export var infoAbove = "_mg-a";
export var internal = "_mg-4";
export var lightActionButton = "_mg-1";
export var link = "_mg-b";
export var merchant = "_mg-5";
export var message = "_mg-c";
export var profilePicture = "_mg-e";
export var quillToolbarContainer = "_mg-f";
export var senderDate = "_mg-g";
export var senderDateCustomer = "_mg-h";
export var senderName = "_mg-d";
export var time = "_mg-k";
export var uploadedImage = "_mg-l";
export var username = "_mg-m";
export var xsmall = "_mg-n";